import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, Save } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { PageHeader, GlassCard, GradButton, Field, fmtMoney } from "@/components/erp";
import { useAuth } from "@/context/AuthContext";
import api, { errMsg } from "@/lib/api";

const Onizleme = ({ o }) => (
  <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mt-3" data-testid="gun-sonu-onizleme">
    {[["Satış", o.satis], ["Sipariş", o.siparis], ["Tahsilat", o.tahsilat], ["Ödeme", o.odeme], ["Gider", o.gider]].map(([l, v]) => (
      <div key={l} className="rounded-lg bg-white/5 p-2.5"><div className="text-[10px] text-muted-foreground">{l} ({v.adet})</div><div className="font-mono text-xs font-semibold">{fmtMoney(v.tutar)}</div></div>))}
  </div>
);

const SirketAlicilari = () => {
  const { ayar, loadAyar } = useAuth();
  const [v, setV] = useState((ayar?.ozet_eposta_listesi || []).join(", "));
  useEffect(() => { setV((ayar?.ozet_eposta_listesi || []).join(", ")); }, [ayar?.ozet_eposta_listesi]);
  const kaydet = async () => {
    try { await api.put("/ayarlar", { ozet_eposta_listesi: v.split(",").map((x) => x.trim()).filter(Boolean) }); await loadAyar(); toast.success("Alıcılar kaydedildi"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <GlassCard className="p-5" data-testid="eposta-sirket">
      <div className="font-semibold text-sm">Şirket geneli · Günlük vade özeti alıcıları</div>
      <p className="text-xs text-muted-foreground mt-1 mb-3">Günlük Özet ekranındaki "E-posta gönder" düğmesi bu adreslere ve muhasebe kullanıcılarına gönderir (virgülle ayırın).</p>
      <div className="flex gap-2"><Input data-testid="eposta-sirket-liste" value={v} onChange={(e) => setV(e.target.value)} className="bg-white/5" />
        <GradButton data-testid="eposta-sirket-kaydet" onClick={kaydet}><Save className="w-4 h-4" />Kaydet</GradButton></div>
      <div className="text-xs text-muted-foreground mt-4 space-y-1"><div className="font-semibold text-foreground/80">Her zaman giden e-postalar (kapatılamaz)</div>
        <div>· Şifre sıfırlama bağlantısı</div><div>· Bayiye: risk onayından geçen siparişin onay e-postası (cari kartındaki kurala göre)</div><div>· Müşteriye: imzalı irsaliye (sevkiyat ekranından gönderildiğinde)</div></div>
    </GlassCard>
  );
};

export default function EPostaAyarlari() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [oz, setOz] = useState(null);
  useEffect(() => {
    api.get("/eposta-tercihleri").then((r) => setD(r.data));
    api.get("/eposta-tercihleri/gun-sonu-onizleme").then((r) => setOz(r.data)).catch(() => setOz(null));
  }, []);
  if (!d) return null;
  const degis = async (k, v) => { try { setD((await api.put("/eposta-tercihleri", { tercihler: { [k]: v } })).data); toast.success(v ? "Açıldı" : "Kapatıldı"); } catch (e) { toast.error(errMsg(e)); } };
  const dene = async () => { try { const r = await api.post("/eposta-tercihleri/gun-sonu-deneme"); toast.success(`Deneme e-postası gönderildi: ${r.data.adres}`); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="eposta-ayarlari-page">
      <PageHeader title="E-Posta Ayarları" desc={`Kişisel tercihleriniz · e-postalar ${d.email} adresine gelir`} />
      <div className="space-y-4 max-w-4xl">
        {d.tercihler.length === 0 && <GlassCard className="p-5 text-sm text-muted-foreground" data-testid="eposta-yok">Rolünüz için seçilebilir bir e-posta bildirimi yok.</GlassCard>}
        {d.tercihler.map((t) => (
          <GlassCard key={t.anahtar} className="p-5" data-testid={`eposta-${t.anahtar}`}>
            <div className="flex items-start gap-4">
              <div className="flex-1"><div className="font-semibold text-sm">{t.baslik}</div><p className="text-xs text-muted-foreground mt-1.5">{t.aciklama}</p></div>
              <Switch data-testid={`eposta-anahtar-${t.anahtar}`} checked={t.acik} onCheckedChange={(v) => degis(t.anahtar, v)} />
            </div>
            {t.anahtar === "gun_sonu_ozet" && <>{oz && <Onizleme o={oz} />}
              <button data-testid="gun-sonu-deneme" onClick={dene} className="mt-3 inline-flex items-center gap-1.5 text-xs px-3 h-8 rounded-lg border border-white/20 hover:bg-white/5"><Send className="w-3.5 h-3.5" />Bugünün özetini şimdi bana gönder</button></>}
          </GlassCard>
        ))}
        {user?.role === "admin" && <SirketAlicilari />}
      </div>
    </div>
  );
}
